import axios from 'axios';
import { CONFIG } from '../../../config';

export async function fetchMetaDataAnalyticStudioService() {
	return axios
		.get(`${CONFIG.api_base_url}v1/analyticsStudio/getmetadata`)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function fetchDataAnalyticStudioService(payload) {
	if (payload.export == 'true') {
		return axios
			.post(`${CONFIG.api_base_url}v1/analyticsStudio/getdata`, payload, {
				responseType: 'blob',
			})
			.then((response) => {
				var x = response.data;
				console.log(response, x);
				var u = URL.createObjectURL(x);
				var a = document.createElement('a');
				a.href = u;
				a.download = response.headers['content-disposition'].split('=')[1];
				a.click();
				window.URL.revokeObjectURL(u);

				return response;
			})
			.catch((err) => err.response);
	}

	return axios
		.post(`${CONFIG.api_base_url}v1/analyticsStudio/getdata`, payload)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getAnalyticStudioService(payload) {
	return axios
		.post(`${CONFIG.api_base_url}v1/analyticsStudio/getanalyticstudio`, payload)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getAnalyticStudioReportService(payload) {
	return axios
		.get(
			`${CONFIG.api_base_url}v1/analyticsStudio/getanalyticstudioreport`,
			payload
		)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getAnalyticStudioSingleReportService(payload) {
	return axios
		.get(
			`${CONFIG.api_base_url}v1/analyticsStudio/getanalyticstudioreport?id=${payload}`,
			payload
		)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function sendEmailForChartService(payload) {
	return axios
		.post(`${CONFIG.api_base_url}v1/analyticsStudio/sendemail`, payload)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function saveAnalyticStudioService(payload) {
	return axios
		.post(
			`${CONFIG.api_base_url}v1/analyticsStudio/saveanalyticstudio`,
			payload
		)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function saveAnalyticStudioReportService(payload) {
	return axios
		.post(
			`${CONFIG.api_base_url}v1/analyticsStudio/saveanalyticstudioreport`,
			payload
		)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteAnalyticStudioService(payload) {
	return axios
		.post(`${CONFIG.api_base_url}v1/analyticsStudio/delete`, payload)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteReportAnalyticStudioService(payload) {
	return axios
		.post(`${CONFIG.api_base_url}v1/analyticsStudio/deletereport`, payload)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function shareChartService(data) {
	let payload = {
		options: JSON.stringify(data.userOptions),
		filename: 'LineChart',
		b64: true,
	};

	let url = 'https://export.highcharts.com/';

	return axios
		.post(url, payload)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
}
